import React from 'react'
import { Box } from '@mui/material'
import { PracticeGoal } from 'src/graphql.generated'
import { useGetPatientProgressTrackerQuery } from './progressTrackerQueries.generated'

const GOAL_LABELS: Record<PracticeGoal, string> = {
  [PracticeGoal.Daily]: 'Daily',
  [PracticeGoal.FiveDay]: '5-day',
  [PracticeGoal.ThreeDay]: '3-day',
}

type Props = {
  uid: string
}

export default function CurrentModuleGoal({ uid }: Props) {
  const { data } = useGetPatientProgressTrackerQuery({ variables: { uid } })

  const currentModule = data?.patient.progressTracker?.modules.find((module) => module.days.some((day) => day.isToday))

  if (!currentModule) return null

  return (
    <Box
      component="span"
      sx={{
        bgcolor: 'secondary.main',
        color: 'common.white',
        borderRadius: '999px',
        px: 1.5,
        py: 0.5,
        fontSize: '0.75rem',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
      }}
    >
      {GOAL_LABELS[currentModule.goal.practiceGoal]} goal
    </Box>
  )
}
